import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Formik } from 'formik';

//for connecting
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/workspace';
import { checkRecordInList } from '../api/timeListProcess'

class Workspacemodal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = { obj: {}, readOnly:false, errors:{phone:''} };
        this.hanadleAddClick = this.hanadleAddClick.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
    }

    componentWillMount(){
        if(this.props.index){
            this.setState({obj: this.props.index, readOnly: (this.props.userPhone !== this.props.index.owner.phone_number)});
        }else{
            this.setState({'obj':{'name': '', 'id': -1, 'users': [], owner:{} }});
        }
    }

    hanadleAddClick(phone){
        if(!/^((\+98)|0)[0-9]{10}$/i.test(phone)) {
            this.setState({errors:{phone: 'شماره موبایل وارد شده معتبر نیست.'}});
        }else if( phone !== this.props.userPhone){
            const duplicate = checkRecordInList( this.state.obj.users, {phone_number: phone}, 'phone_number');
            if( !duplicate && duplicate !== 0 ){
                this.setState({errors:{phone: ''}});
                let userList = this.state.obj.users || [];
                userList.push({phone_number:phone, name:''})
                this.setState({ obj: { ...this.state.obj, users: userList }, phone:''})
            }else{
                this.setState({errors:{phone: 'کاربر در لیست وجود دارد.'}});
            }
        }else{
            this.setState({errors:{phone: 'مدیر محیط کاری را نمیتوان به لیست کاربران اضافه کرد.'}});
        }
    }

    handleKeyPress(e){
        if(e.key === 'Enter'){
            e.preventDefault();
            this.hanadleAddClick(e.target.value)
        }
    }

    deleteUser(index){
        let userList = this.state.obj.users || [];
        userList.splice(index, 1)
        this.setState({ obj: { ...this.state.obj, users: userList }})
    }

    handleTextChange(e){
        this.setState({phone: e.target.value})
    }
  
    render() {
        const obj = this.state.obj;
        const allUsers = this.state.obj.users;
        const mappedUsers = allUsers.map((user,index) => (
            <tr key={index}>
                <td>{index+1}</td>
                <td>{user.name.trunc(25)}</td>
                <td>{user.phone_number}</td>
                {(this.state.readOnly)?(null):(<td>
                    {(user.phone_number !== this.props.userPhone)?
                    (<i className="glyphicon glyphicon-trash" onClick={()=>{this.deleteUser(index)}}>
                    </i>):(null)}
                </td>)}
            </tr>
        ));
        return (
            <Modal backdrop="static" show={true} onHide={this.props.toggleModal}>
            
                <Formik 
                    initialValues = {{
                        name: obj.name,
                        phone: ""
                    }}
                    validate = {values => {

                        let errors = {};
                        if(!values.name || values.name === '') errors.name = 'وارد کردن نام محیط کار الزامی است';
                        return errors;
                    }}
                    onSubmit = {(values,actions) => {
                        this.props.updateData(this.state.obj, values, this.props.toggleModal)
                    }}
                    render = {
                        ({values, errors, touched, handleChange, handleSubmit, isSubmitting}) => (
                            <form name="projectForm" onSubmit={handleSubmit} >
                                <Modal.Header>
                                    <div className="col-md-5">
                                        <Modal.Title>
                                            { (this.props.index>-1)? ('ویرایش محیط کار'):('افزودن محیط کار')}
                                        </Modal.Title>
                                    </div>
                                    <div className="pull-left">
                                        {(this.state.readOnly || this.props.app.loading!==0 ) || (<Button type="submit" bsStyle="success"  style={{marginLeft:'5px'}}>ذخیره</Button>) } 
                                        <Button bsStyle="danger" onClick={this.props.toggleModal}>بستن</Button>
                                    </div>
                                </Modal.Header>
                                <Modal.Body>
                                {
                                    this.props.app.loading!==0 || 
                                    (                    
                                    <fieldset >
                                        <div className="row extended-row">
                                            <div className="col-md-8 col-md-push-2 form-group">
                                                <label>نام محیط کار*</label>
                                                <input readOnly={this.state.readOnly} type="text" name="name" value={values.name} onChange={handleChange}
                                                className={ errors.name && touched.name ? ('form-control invalid-input') : ('form-control')} />
                                                {touched.name && errors.name && <div className="invalid-feedback" >{errors.name}</div>}
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                        <hr/>
                                        <div className="row" >
                                            <div className="col-md-8 col-md-push-2">
                                                <label>همکاران محیط کار</label>
                                                {(this.state.readOnly)?(null):(
                                                <div className="input-group">
                                                    <input name="phone" type="text" placeholder="شماره موبایل" value={this.state.phone || ''} onKeyPress={this.handleKeyPress} onChange={this.handleTextChange} className="form-control" />
                                                    <span className="input-group-addon" onClick={()=>{this.hanadleAddClick(this.state.phone)}}>
                                                        {(true)?
                                                        <i className="glyphicon glyphicon-ok"></i>
                                                        :
                                                        <i className="glyphicon glyphicon-repeat"></i>
                                                        }
                                                    </span>
                                                </div>)}
                                                { this.state.errors.phone && <div className="invalid-feedback text-center" >{this.state.errors.phone}</div>}
                                                <br/>
                                                {(mappedUsers.length > 0)?(
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>ردیف</th>
                                                            <th>نام</th>
                                                            <th>شماره موبایل</th>
                                                            {(this.state.readOnly)?(null):(<th></th>)}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {mappedUsers}
                                                    </tbody>
                                                </table>
                                                ):(null)}
                                            </div>
                                        </div>

                                        <div className="clearfix"></div>
                                    </fieldset>
                                    )
                                }
                                </Modal.Body>
                            </form>
                        )
                    }
                />
                
            <Modal.Footer>
                <p> 
                    پر کردن فیلد هایی که با * مشخص شده اجباری است
                </p>
            </Modal.Footer>
          </Modal>
      );
    }
  }
  
function mapStateToProps(state) {
  return {
    app: state.app,
  }
}

Workspacemodal.defaultProps = {
    index : -1
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(Workspacemodal);